import {analyticsConstants} from '../../constants';
import {GlobalAnalyticsVariablesInterface, TrackCtcTermsPageViewPayloadInterface} from '../interfaces';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackCtcTermsPageViewPayloadCase = (
  pageName: string,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackCtcTermsPageViewPayloadInterface => {
  const data = {
    pageName,
    interaction: 'checkin:guest-terms',
    eventType: analyticsConstants.INTERACTION_EVENT_TYPE
  };
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
};
